/**
 * GSAP 공통 애니메이션 유틸리티
 * 여러 페이지에서 재사용되는 애니메이션 함수들
 */

/**
 * 이미지 스크롤 패럴랙스 애니메이션
 * @param {string} selector - 이미지 선택자 (기본값: '.move-img img')
 * @param {object} options - 옵션 객체
 * @param {number} options.yPercent - 초기 y 위치 (기본값: -10)
 * @param {number} options.scale - 스케일 값 (기본값: 1.1)
 */
export function initScrollImageAnimation(selector = '.move-img img', options = {}) {
  const { yPercent = -10, scale = 1.1 } = options;

  const images = document.querySelectorAll(selector);

  if (images.length > 0) {
    gsap.set(images, {
      scale: scale,
    });

    images.forEach((image) => {
      gsap.fromTo(
        image,
        { yPercent: yPercent },
        {
          yPercent: 0,
          scrollTrigger: {
            trigger: image,
            start: 'top-=10% bottom',
            end: 'bottom+=20% top',
            scrub: 1,
          },
        }
      );
    });
  }
}

/**
 * 리스트 항목 순차 애니메이션
 * @param {string} selector - 리스트 선택자 (기본값: '.list-js')
 * @param {object} options - 옵션 객체
 * @param {number} options.duration - 애니메이션 지속 시간 (기본값: 0.9)
 * @param {number} options.stagger - 항목 간 지연 시간 (기본값: 0.3)
 * @param {number} options.y - 초기 y 위치 (기본값: 50)
 */
export function initListAnimation(selector = '.list-js', options = {}) {
  const { duration = 0.9, stagger = 0.3, y = 50 } = options;

  const lists = document.querySelectorAll(selector);

  if (lists.length > 0) {
    lists.forEach((list) => {
      const items = list.querySelectorAll(':scope > li');

      gsap.fromTo(
        items,
        { opacity: 0, y: y },
        {
          opacity: 1,
          y: 0,
          duration: duration,
          stagger: stagger,
          clearProps: 'y',
          scrollTrigger: {
            trigger: list,
            start: 'top 80%',
            end: 'bottom 20%',
          },
        }
      );
    });
  }
}


